import Link from '@mui/material/Link';

export default function LinkWrapper({ linkHref, children }) {
  if (linkHref)
    return (
      <Link color="textPrimary" href={linkHref}>
        {children}
      </Link>
    );
  return children;
}
